import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 2A113842-ED83-4F44-B7DE-A0AFF5DDB452
 * name format-text-rotation-up
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-text-rotation-up.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatTextRotationUpIcon = createSvgIcon(<><path d="M3 12V13.5L14 18.25V16.15L11.8 15.25V10.25L14 9.35V7.25L3 12M10 14.62L5 12.75L10 10.88V14.62M18 4.25L15 7.25H17V19.75H19V7.25H21L18 4.25Z" /></>, 'FormatTextRotationUpIcon');
export default FormatTextRotationUpIcon